const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Airport%20terminal%20with%20natural%20light%20streaming%20through%20large%20windows%2C%20casual%20travel%20scene%2C%20cinematic%20documentary%20style%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20editorial%20photography%20with%20soft%20focus%20background&width=800&height=500&seq=media-gossip-01&orientation=landscape',
    duration: '05:32',
    title: '独家：某女星机场素颜照对比，网友直呼认不出',
    desc: '当红女星近日被拍到素颜现身机场，与精修图差距明显，引发网友热议',
    views: '89.7万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Backstage%20area%20of%20a%20fashion%20event%20with%20clothing%20racks%20and%20mirrors%2C%20slightly%20chaotic%20yet%20glamorous%20atmosphere%2C%20warm%20lighting%20with%20soft%20highlights%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=media-gossip-02&orientation=landscape',
    duration: '03:18',
    title: '现场直击：某时尚活动后台混乱画面曝光',
    desc: '某大型时尚活动后台被拍到管理混乱，多位艺人面露不悦神色',
    views: '67.2万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Digital%20ranking%20board%20with%20glowing%20warm%20numbers%20and%20data%20visualizations%2C%20modern%20infographic%20style%2C%20amber%20and%20warm%20gray%20color%20scheme%2C%20clean%20minimalist%20design%2C%20editorial%20layout&width=800&height=500&seq=media-gossip-03&orientation=landscape',
    duration: '08:45',
    title: '盘点：2024上半年塌房明星完整时间线',
    desc: '从顶流到新秀，细数今年上半年那些让人大跌眼镜的翻车事件',
    views: '156.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Professional%20video%20editing%20workstation%20with%20timeline%20scrubbing%20interface%20displaying%20frame%20by%20frame%20analysis%2C%20warm%20screen%20glow%2C%20documentary%20production%20style%2C%20clean%20editorial%20composition&width=800&height=500&seq=media-gossip-04&orientation=landscape',
    duration: '12:06',
    title: '分析：某综艺争议片段，逐帧解读背后的真相',
    desc: '技术流深扒某综艺节目中引发争议的片段，还原事件真实过程',
    views: '204.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20behind%20frosted%20glass%20in%20a%20dimly%20lit%20office%2C%20confidential%20documents%20vibe%2C%20dramatic%20lighting%20with%20warm%20amber%20accents%2C%20investigative%20journalism%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=media-gossip-05&orientation=landscape',
    duration: '15:20',
    title: '揭秘：娱乐圈不可说的潜规则，圈内人亲述',
    desc: '多位匿名圈内人士接受采访，揭露影视行业不为人知的幕后规则',
    views: '312.8万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">视频速递</h2>
          <p className="text-sm text-foreground-500">热门吃瓜视频精选，深度解析争议事件</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((m, i) => (
            <div key={i} className={`bg-background-50 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.02] cursor-pointer group ${i >= 3 ? 'lg:col-span-1' : ''}`}>
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={m.image}
                  alt={m.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs font-mono">
                  {m.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">{m.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{m.desc}</p>
                <div className="flex items-center text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  <span>{m.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}